import { z } from "zod";

export const EVMTokenAddress = z
    .string()
    .regex(/^0x[a-fA-F0-9]*$/, {
        message: "Must be a hex string beginning with 0x",
    })
    .transform((a) => a as `0x${string}`);
export type EVMTokenAddress = z.infer<typeof EVMTokenAddress>;

export const EVMAddress = z
    .string()
    .regex(/^0x[a-fA-F0-9]{40}$/, {
        message: "Must be a 40-character hex string beginning with 0x",
    })
    .transform((a) => a.toLowerCase() as `0x${string}`);
export type EVMAddress = z.infer<typeof EVMAddress>;

export const SolAddress = z.string();
export type SolAddress = z.infer<typeof SolAddress>;

export const Address = z.string();
export type Address = z.infer<typeof Address>;

export const AddressFamilyMap = z.object(
    {
        EVM: EVMAddress,
        SOL: SolAddress,
    } satisfies Record<string, z.ZodType<Address>>,
);
export type AddressFamilyMap = z.infer<typeof AddressFamilyMap>;

export const AddressFamily = AddressFamilyMap.keyof();
export type AddressFamily = z.infer<typeof AddressFamily>;

export const Amount = z.string().regex(/^(\d+|\d*\.\d+)$/);
export type Amount = z.infer<typeof Amount>;

export const Balance = z.bigint();
export type Balance = z.infer<typeof Balance>;

export const Sau = z.bigint().min(0n);
export type Sau = z.infer<typeof Sau>;

export const BlockNumber = z.bigint().min(0n);
export type BlockNumber = z.infer<typeof BlockNumber>;

export const Milliseconds = z.number();
export type Milliseconds = z.infer<typeof Milliseconds>;

export const TxId = z.string();
export type TxId = z.infer<typeof TxId>;
